// import React, { useEffect, useState } from "react";
// import { useAuthState } from "react-firebase-hooks/auth";
// import toast from "react-hot-toast";
// import { Link } from "react-router-dom";
// import auth from "../../firebase.init"; // Adjust path as needed
// import { Helmet } from "react-helmet";

// const PendingOrders = () => {
//   const [user] = useAuthState(auth);
//   const [loading, setLoading] = useState(true);
//   const [orders, setOrders] = useState([]); // For standard orders
//   const [itemOrders, setItemOrders] = useState([]); // For item orders (will now use packageName/packagePrice)
//   const [activeTab, setActiveTab] = useState("standard"); // 'standard' or 'items'
//   const [currentPageStandard, setCurrentPageStandard] = useState(1);
//   const [currentPageItems, setCurrentPageItems] = useState(1);
//   const [itemsPerPage] = useState(10);

//   // --- Data Fetching Functions ---
//   const fetchOrders = async () => {
//     if (user?.email) {
//       try {
//         const response = await fetch(
//           `https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/orders?userEmail=${user.email}`
//         );
//         const info = await response.json();

//         // Sort by createdAt descending (latest first)
//         const sortedInfo = info.sort((a, b) => {
//           const dateA = new Date(a.createdAt || 0);
//           const dateB = new Date(b.createdAt || 0);
//           return dateB - dateA; // Descending order
//         });

//         setOrders(sortedInfo);
//       } catch (error) {
//         console.error("Error fetching standard orders:", error);
//         toast.error("Could not load standard orders. Please try again.");
//       }
//     }
//   };
//   const fetchItemOrders = async () => {
//     if (user?.email) {
//       try {
//         const response = await fetch(
//           `https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/item-orders?userEmail=${user.email}`
//         );
//         const info = await response.json();

//         // Sort by createdAt descending (latest first)
//         const sortedInfo = info.sort((a, b) => {
//           const dateA = new Date(a.createdAt || 0);
//           const dateB = new Date(b.createdAt || 0);
//           return dateB - dateA; // Descending order
//         });

//         setItemOrders(sortedInfo);
//       } catch (error) {
//         console.error("Error fetching item orders:", error);
//         toast.error("Could not load item orders. Please try again.");
//       }
//     }
//   };

//   // --- Initial Data Fetch on Component Mount/User Change ---
//   useEffect(() => {
//     const fetchAllData = async () => {
//       if (user?.email) {
//         setLoading(true);
//         // Fetch both types of orders concurrently
//         await Promise.all([fetchOrders(), fetchItemOrders()]);
//         setLoading(false);
//       } else {
//         setLoading(false); // If no user email, stop loading
//       }
//     };
//     fetchAllData();
//   }, [user]); // Dependency on user to re-fetch if user changes

//   // --- Filtering Pending Orders ---
//   const pendingStandardOrders = orders.filter(
//     (order) =>
//       order.paymentStatus && order.paymentStatus.toLowerCase() === "pending"
//   );

//   const pendingItemOrders = itemOrders.filter(
//     (order) =>
//       order.paymentStatus && order.paymentStatus.toLowerCase() === "pending"
//   );

//   // --- Pagination Logic ---
//   const getPaginatedOrders = (data, currentPage) => {
//     const indexOfLastItem = currentPage * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     return data.slice(indexOfFirstItem, indexOfLastItem);
//   };

//   const paginatedStandardOrders = getPaginatedOrders(
//     pendingStandardOrders,
//     currentPageStandard
//   );
//   const paginatedItemOrders = getPaginatedOrders(
//     pendingItemOrders,
//     currentPageItems
//   );

//   const totalPagesStandard = Math.ceil(
//     pendingStandardOrders.length / itemsPerPage
//   );
//   const totalPagesItems = Math.ceil(pendingItemOrders.length / itemsPerPage);

//   const handlePageChange = (tab, pageNumber) => {
//     if (tab === "standard") {
//       setCurrentPageStandard(pageNumber);
//     } else {
//       setCurrentPageItems(pageNumber);
//     }
//   };

//   // --- Utility Functions for UI ---
//   const getStatusBadgeClass = (status) => {
//     if (!status) return "bg-info text-white";
//     status = status.toLowerCase();
//     if (status === "pending") return "bg-warning text-dark";
//     if (status === "completed") return "bg-success text-white";
//     return "bg-info text-white";
//   };

//   const getPayNowLink = (order, type) => {
//     if (type === "item") {
//       return `/item-pay-now/${order._id}`;
//     }
//     return `/pay-now/${order._id}`;
//   };

//   // --- Loading State ---
//   if (loading) {
//     return (
//       <div className="d-flex justify-content-center align-items-center min-vh-100">
//         <div
//           className="spinner-border text-primary"
//           role="status"
//           style={{ width: "3rem", height: "3rem" }}
//         >
//           <span className="visually-hidden">Loading...</span>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <>
//       <Helmet>
//         <title>Pending Orders | Your Website</title>
//         <meta
//           name="description"
//           content="View and manage your pending standard and item orders. Complete payments to finalize your purchases."
//         />
//       </Helmet>

//       <main className="container py-5">
//         {/* Page Header */}
//         <div className="row mb-4">
//           <div className="col-12">
//             <div className="card shadow-sm border-0">
//               <div className="card-body p-4">
//                 <h2 className="card-title fs-3 fw-bold mb-1">
//                   My Pending Orders
//                 </h2>
//                 <p className="text-muted mb-0">
//                   Manage all your pending payments for both standard and item
//                   purchases.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Tab Navigation */}
//         <ul className="nav nav-pills nav-fill mb-4 p-2 bg-light rounded-3 shadow-sm">
//           <li className="nav-item">
//             <button
//               className={`nav-link fw-bold ${
//                 activeTab === "standard" ? "active" : ""
//               }`}
//               onClick={() => setActiveTab("standard")}
//             >
//               Standard Orders ({pendingStandardOrders.length})
//             </button>
//           </li>
//           <li className="nav-item">
//             <button
//               className={`nav-link fw-bold ${
//                 activeTab === "items" ? "active" : ""
//               }`}
//               onClick={() => setActiveTab("items")}
//             >
//               Item Orders ({pendingItemOrders.length})
//             </button>
//           </li>
//         </ul>

//         {/* --- Standard Orders Section (Conditionally Rendered) --- */}
//         {activeTab === "standard" && (
//           <div className="card border-0 shadow-sm">
//             <div className="card-header bg-white py-3 border-0">
//               <div className="d-flex justify-content-between align-items-center">
//                 <h3 className="fs-4 fw-bold mb-0">Pending Standard Orders</h3>
//               </div>
//             </div>
//             <div className="card-body p-0">
//               {/* Desktop Table View */}
//               <div className="table-responsive d-none d-md-block">
//                 <table className="table table-hover align-middle mb-0">
//                   <thead className="bg-light">
//                     <tr>
//                       <th className="py-3 ps-4">Order Info</th>
//                       <th className="py-3">Amount</th>
//                       <th className="py-3">Status</th>
//                       <th className="py-3 text-end pe-4">Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {paginatedStandardOrders.length > 0 ? (
//                       paginatedStandardOrders.map((order) => (
//                         <tr key={order._id}>
//                           <td className="py-3 ps-4">
//                             <div className="d-flex align-items-center">
//                               <div
//                                 className="rounded-3 bg-light d-flex align-items-center justify-content-center me-3"
//                                 style={{
//                                   width: "48px",
//                                   height: "48px",
//                                   overflow: "hidden",
//                                 }}
//                               >
//                                 <img
//                                   src={
//                                     order.featuredImage ||
//                                     "/assets/img/dashboard/orders/o-1.png"
//                                   }
//                                   alt={order.packageName || "Order"}
//                                   className="img-fluid"
//                                   style={{
//                                     objectFit: "cover",
//                                     width: "100%",
//                                     height: "100%",
//                                   }}
//                                   onError={(e) => {
//                                     e.target.onerror = null;
//                                     e.target.src =
//                                       "https://placehold.co/48x48/e9ecef/6c757d?text=FB";
//                                   }}
//                                 />
//                               </div>
//                               <div>
//                                 <h6 className="fw-bold mb-1">
//                                   {order.packageName || "Unnamed Package"}
//                                 </h6>
//                                 <div className="d-flex flex-column flex-md-row align-md-items-center">
//                                   <small className="text-secondary me-md-3">
//                                     ID: {order.orderId || "N/A"}
//                                   </small>
//                                   <small className="text-secondary d-none d-md-block">
//                                     <i className="bi bi-calendar-date me-1"></i>
//                                     {order.orderDate || "N/A"}
//                                   </small>
//                                 </div>
//                               </div>
//                             </div>
//                           </td>
//                           <td className="py-3">
//                             <span className="fw-bold">
//                               ${order.packagePrice || "0.00"} USD
//                             </span>
//                           </td>
//                           <td className="py-3">
//                             <span
//                               className={`badge rounded-pill ${getStatusBadgeClass(
//                                 order.paymentStatus
//                               )} px-3 py-2`}
//                               style={{ fontSize: "0.85rem" }}
//                             >
//                               {order.paymentStatus
//                                 ? order.paymentStatus[0].toUpperCase() +
//                                   order.paymentStatus.slice(1)
//                                 : "Pending"}
//                             </span>
//                           </td>
//                           <td className="py-3 text-end pe-4 d-none d-md-table-cell">
//                             <Link
//                               to={getPayNowLink(order, "standard")}
//                               className="btn btn-primary btn-sm rounded-pill px-3 fw-medium"
//                             >
//                               <i className="bi bi-credit-card me-1"></i> Pay Now
//                             </Link>
//                           </td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="4" className="text-center py-5">
//                           <div className="d-flex flex-column align-items-center">
//                             <div className="mb-3">
//                               <i className="bi bi-inbox fs-1 text-secondary opacity-50"></i>
//                             </div>
//                             <h5 className="fw-semibold mb-2">
//                               No Pending Standard Orders
//                             </h5>
//                             <p className="text-muted">
//                               You're all caught up with standard payments.
//                             </p>
//                           </div>
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>

//               {/* Mobile Card View */}
//               <div className="d-block d-md-none">
//                 {paginatedStandardOrders.length > 0 ? (
//                   paginatedStandardOrders.map((order) => (
//                     <div
//                       key={order._id}
//                       className="card mb-3 shadow-sm border-0"
//                     >
//                       <div className="card-body">
//                         <div className="d-flex align-items-center mb-3">
//                           <div
//                             className="rounded-3 bg-light d-flex align-items-center justify-content-center me-3"
//                             style={{
//                               width: "48px",
//                               height: "48px",
//                               overflow: "hidden",
//                             }}
//                           >
//                             <img
//                               src={
//                                 order.featuredImage ||
//                                 "/assets/img/dashboard/orders/o-1.png"
//                               }
//                               alt={order.packageName || "Order"}
//                               className="img-fluid"
//                               style={{
//                                 objectFit: "cover",
//                                 width: "100%",
//                                 height: "100%",
//                               }}
//                               onError={(e) => {
//                                 e.target.onerror = null;
//                                 e.target.src =
//                                   "https://placehold.co/48x48/e9ecef/6c757d?text=FB";
//                               }}
//                             />
//                           </div>
//                           <div>
//                             <h6 className="fw-bold mb-1">
//                               {order.packageName || "Unnamed Package"}
//                             </h6>
//                             <small className="text-secondary">
//                               ID: {order.orderId}
//                             </small>
//                             <br />
//                             <small className="text-secondary">
//                               <i className="bi bi-calendar-date me-1"></i>{" "}
//                               {order.orderDate || "N/A"}
//                             </small>
//                           </div>
//                         </div>

//                         <div className="mb-2">
//                           <strong>Amount:</strong>{" "}
//                           <span className="fw-bold">
//                             ${order.packagePrice || "0.00"} USD
//                           </span>
//                         </div>

//                         <div className="mb-2">
//                           <strong>Status:</strong>{" "}
//                           <span
//                             className={`badge rounded-pill ${getStatusBadgeClass(
//                               order.paymentStatus
//                             )} px-3 py-2`}
//                             style={{ fontSize: "0.85rem" }}
//                           >
//                             {order.paymentStatus
//                               ? order.paymentStatus[0].toUpperCase() +
//                                 order.paymentStatus.slice(1)
//                               : "Pending"}
//                           </span>
//                         </div>

//                         <div className="text-center">
//                           <Link
//                             to={getPayNowLink(order, "standard")}
//                             className="btn btn-primary rounded-pill px-4 py-2 fw-medium mt-2"
//                           >
//                             <i className="bi bi-credit-card me-1"></i> Pay Now
//                           </Link>
//                         </div>
//                       </div>
//                       <hr></hr>
//                     </div>
//                   ))
//                 ) : (
//                   <div className="text-center py-5">
//                     <i className="bi bi-inbox fs-1 text-secondary opacity-50 mb-3"></i>
//                     <h5 className="fw-semibold">No Pending Standard Orders</h5>
//                     <p className="text-muted">
//                       You're all caught up with standard payments.
//                     </p>
//                   </div>
//                 )}
//               </div>

//               {/* Pagination for Standard Orders */}
//               {pendingStandardOrders.length > itemsPerPage && (
//                 <div className="d-flex justify-content-center py-3 border-top">
//                   <nav aria-label="Page navigation for standard orders">
//                     <ul className="pagination">
//                       <li
//                         className={`page-item ${
//                           currentPageStandard === 1 ? "disabled" : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() =>
//                             handlePageChange(
//                               "standard",
//                               currentPageStandard - 1
//                             )
//                           }
//                           disabled={currentPageStandard === 1}
//                           aria-label="Previous"
//                         >
//                           <span aria-hidden="true">&laquo;</span>
//                         </button>
//                       </li>
//                       {[...Array(totalPagesStandard)].map((_, i) => (
//                         <li
//                           key={`standard-page-${i + 1}`}
//                           className={`page-item ${
//                             currentPageStandard === i + 1 ? "active" : ""
//                           }`}
//                         >
//                           <button
//                             className="page-link"
//                             onClick={() => handlePageChange("standard", i + 1)}
//                           >
//                             {i + 1}
//                           </button>
//                         </li>
//                       ))}
//                       <li
//                         className={`page-item ${
//                           currentPageStandard === totalPagesStandard
//                             ? "disabled"
//                             : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() =>
//                             handlePageChange(
//                               "standard",
//                               currentPageStandard + 1
//                             )
//                           }
//                           disabled={currentPageStandard === totalPagesStandard}
//                           aria-label="Next"
//                         >
//                           <span aria-hidden="true">&raquo;</span>
//                         </button>
//                       </li>
//                     </ul>
//                   </nav>
//                 </div>
//               )}
//             </div>
//           </div>
//         )}

//         {/* --- Item Orders Section (Conditionally Rendered) --- */}
//         {activeTab === "items" && (
//           <div className="card border-0 shadow-sm">
//             <div className="card-header bg-white py-3 border-0">
//               <div className="d-flex justify-content-between align-items-center">
//                 <h3 className="fs-4 fw-bold mb-0">Pending Item Orders</h3>
//               </div>
//             </div>
//             <div className="card-body p-0">
//               {/* Desktop Table View */}
//               <div className="table-responsive d-none d-md-block">
//                 <table className="table table-hover align-middle mb-0">
//                   <thead className="bg-light">
//                     <tr>
//                       <th className="py-3 ps-4">Item Info</th>{" "}
//                       {/* Changed from Order Info to Item Info */}
//                       <th className="py-3">Amount</th>
//                       <th className="py-3">Status</th>
//                       <th className="py-3 text-end pe-4">Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {paginatedItemOrders.length > 0 ? (
//                       paginatedItemOrders.map((order) => (
//                         <tr key={order._id}>
//                           <td className="py-3 ps-4">
//                             <div className="d-flex align-items-center">
//                               <div
//                                 className="rounded-3 bg-light d-flex align-items-center justify-content-center me-3"
//                                 style={{
//                                   width: "48px",
//                                   height: "48px",
//                                   overflow: "hidden",
//                                 }}
//                               >
//                                 <img
//                                   src={
//                                     order.imageUrl ||
//                                     "https://placehold.co/48x48/e9ecef/6c757d?text=IMG"
//                                   }
//                                   alt={order.packageName || "Item Order"}
//                                   className="img-fluid"
//                                   style={{
//                                     objectFit: "cover",
//                                     width: "100%",
//                                     height: "100%",
//                                   }}
//                                   onError={(e) => {
//                                     e.target.onerror = null;
//                                     e.target.src =
//                                       "https://placehold.co/48x48/e9ecef/6c757d?text=FB";
//                                   }}
//                                 />
//                               </div>
//                               <div>
//                                 <h6 className="fw-bold mb-1">
//                                   <Link
//                                     to={`/premium/${order.slug}/${order.itemId}`}
//                                   >
//                                     {order.packageName || "Unnamed Item"}
//                                   </Link>
//                                 </h6>
//                                 <div className="d-flex flex-column flex-md-row align-md-items-center">
//                                   <small className="text-secondary me-md-3">
//                                     ID: {order.orderId || "N/A"}
//                                   </small>
//                                   <small className="text-secondary d-none d-md-block">
//                                     <i className="bi bi-calendar-date me-1"></i>
//                                     {order.orderDate || "N/A"}
//                                   </small>
//                                 </div>
//                               </div>
//                             </div>
//                           </td>
//                           <td className="py-3">
//                             <span className="fw-bold">
//                               ${order.packagePrice || "0.00"}{" "} USD
//                               {/* Changed to packagePrice */}
//                             </span>
//                           </td>
//                           <td className="py-3">
//                             <span
//                               className={`badge rounded-pill ${getStatusBadgeClass(
//                                 order.paymentStatus
//                               )} px-3 py-2`}
//                               style={{ fontSize: "0.85rem" }}
//                             >
//                               {order.paymentStatus
//                                 ? order.paymentStatus[0].toUpperCase() +
//                                   order.paymentStatus.slice(1)
//                                 : "Pending"}
//                             </span>
//                           </td>
//                           <td className="py-3 text-end pe-4 d-none d-md-table-cell">
//                             <Link
//                               to={getPayNowLink(order, "item")}
//                               className="btn btn-primary btn-sm rounded-pill px-3 fw-medium"
//                             >
//                               <i className="bi bi-credit-card me-1"></i> Pay Now
//                             </Link>
//                           </td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="4" className="text-center py-5">
//                           <div className="d-flex flex-column align-items-center">
//                             <div className="mb-3">
//                               <i className="bi bi-inbox fs-1 text-secondary opacity-50"></i>
//                             </div>
//                             <h5 className="fw-semibold mb-2">
//                               No Pending Item Orders
//                             </h5>
//                             <p className="text-muted">
//                               You're all caught up with item payments.
//                             </p>
//                           </div>
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>

//               {/* Mobile Card View */}
//               <div className="d-block d-md-none">
//                 {paginatedItemOrders.length > 0 ? (
//                   paginatedItemOrders.map((order) => (
//                     <div
//                       key={order._id}
//                       className="card mb-3 shadow-sm border-0"
//                     >
//                       <div className="card-body">
//                         <div className="d-flex align-items-center mb-3">
//                           <div
//                             className="rounded-3 bg-light d-flex align-items-center justify-content-center me-3"
//                             style={{
//                               width: "48px",
//                               height: "48px",
//                               overflow: "hidden",
//                             }}
//                           >
//                             <img
//                               src={
//                                 order.featuredImage ||
//                                 "/assets/img/dashboard/orders/o-1.png"
//                               }
//                               alt={order.packageName || "Item Order"}
//                               className="img-fluid"
//                               style={{
//                                 objectFit: "cover",
//                                 width: "100%",
//                                 height: "100%",
//                               }}
//                               onError={(e) => {
//                                 e.target.onerror = null;
//                                 e.target.src =
//                                   "https://placehold.co/48x48/e9ecef/6c757d?text=FB";
//                               }}
//                             />
//                           </div>
//                           <div>
//                             <h6 className="fw-bold mb-1">
//                               {order.packageName || "Unnamed Item"}{" "}
//                               {/* Changed to packageName */}
//                             </h6>
//                             <small className="text-secondary">
//                               ID: {order.orderId}
//                             </small>
//                             <br />
//                             <small className="text-secondary">
//                               <i className="bi bi-calendar-date me-1"></i>{" "}
//                               {order.orderDate || "N/A"}
//                             </small>
//                           </div>
//                         </div>

//                         <div className="mb-2">
//                           <strong>Amount:</strong>{" "}
//                           <span className="fw-bold">
//                             ${order.packagePrice || "0.00"}{" "} 
//                           </span>
//                         </div>

//                         <div className="mb-2">
//                           <strong>Status:</strong>{" "}
//                           <span
//                             className={`badge rounded-pill ${getStatusBadgeClass(
//                               order.paymentStatus
//                             )} px-3 py-2`}
//                             style={{ fontSize: "0.85rem" }}
//                           >
//                             {order.paymentStatus
//                               ? order.paymentStatus[0].toUpperCase() +
//                                 order.paymentStatus.slice(1)
//                               : "Pending"}
//                           </span>
//                         </div>

//                         <div className="text-center">
//                           <Link
//                             to={getPayNowLink(order, "item")}
//                             className="btn btn-primary rounded-pill px-4 py-2 fw-medium mt-2"
//                           >
//                             <i className="bi bi-credit-card me-1"></i> Pay Now
//                           </Link>
//                         </div>
//                       </div>
//                       <hr></hr>
//                     </div>
//                   ))
//                 ) : (
//                   <div className="text-center py-5">
//                     <i className="bi bi-inbox fs-1 text-secondary opacity-50 mb-3"></i>
//                     <h5 className="fw-semibold">No Pending Item Orders</h5>
//                     <p className="text-muted">
//                       You're all caught up with item payments.
//                     </p>
//                   </div>
//                 )}
//               </div>

//               {/* Pagination for Item Orders */}
//               {pendingItemOrders.length > itemsPerPage && (
//                 <div className="d-flex justify-content-center py-3 border-top">
//                   <nav aria-label="Page navigation for item orders">
//                     <ul className="pagination">
//                       <li
//                         className={`page-item ${
//                           currentPageItems === 1 ? "disabled" : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() =>
//                             handlePageChange("items", currentPageItems - 1)
//                           }
//                           disabled={currentPageItems === 1}
//                           aria-label="Previous"
//                         >
//                           <span aria-hidden="true">&laquo;</span>
//                         </button>
//                       </li>
//                       {[...Array(totalPagesItems)].map((_, i) => (
//                         <li
//                           key={`item-page-${i + 1}`}
//                           className={`page-item ${
//                             currentPageItems === i + 1 ? "active" : ""
//                           }`}
//                         >
//                           <button
//                             className="page-link"
//                             onClick={() => handlePageChange("items", i + 1)}
//                           >
//                             {i + 1}
//                           </button>
//                         </li>
//                       ))}
//                       <li
//                         className={`page-item ${
//                           currentPageItems === totalPagesItems ? "disabled" : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() =>
//                             handlePageChange("items", currentPageItems + 1)
//                           }
//                           disabled={currentPageItems === totalPagesItems}
//                           aria-label="Next"
//                         >
//                           <span aria-hidden="true">&raquo;</span>
//                         </button>
//                       </li>
//                     </ul>
//                   </nav>
//                 </div>
//               )}
//             </div>
//           </div>
//         )}

//         {/* Additional Info Card (shown regardless of tab) */}
//         <div className="card border-0 shadow-sm mt-4">
//           <div className="card-body p-4">
//             <div className="row align-items-center">
//               <div className="col-md-8">
//                 <h4 className="fs-5 fw-bold mb-2">Complete Your Purchase</h4>
//                 <p className="mb-0 text-secondary">
//                   Your orders are pending payment. Complete the payment process
//                   to gain immediate access to your purchased items.
//                 </p>
//               </div>
//               <div className="col-md-4 text-md-end mt-3 mt-md-0">
//                 {/* Pay first order button based on active tab */}
//                 {activeTab === "standard" &&
//                   pendingStandardOrders.length > 0 && (
//                     <Link
//                       to={getPayNowLink(pendingStandardOrders[0], "standard")}
//                       className="btn btn-primary rounded-pill px-4 py-2 fw-medium"
//                     >
//                       <i className="bi bi-credit-card me-2"></i> Pay First
//                       Standard Order
//                     </Link>
//                   )}
//                 {activeTab === "items" && pendingItemOrders.length > 0 && (
//                   <Link
//                     to={getPayNowLink(pendingItemOrders[0], "item")}
//                     className="btn btn-primary rounded-pill px-4 py-2 fw-medium"
//                   >
//                     <i className="bi bi-credit-card me-2"></i> Pay First Item
//                     Order
//                   </Link>
//                 )}
//                 {/* If no pending orders on either tab, show a generic message or hide the button */}
//                 {pendingStandardOrders.length === 0 &&
//                   pendingItemOrders.length === 0 && (
//                     <p className="text-muted mb-0 d-md-inline-block">
//                       No payments due.
//                     </p>
//                   )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </main>

//       {/* Add Bootstrap Icons CSS */}
//       <Helmet>
//         <link
//           rel="stylesheet"
//           href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css"
//         />
//       </Helmet>
//     </>
//   );
// };

// export default PendingOrders;

import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import auth from "../../firebase.init";

const PendingOrders = () => {
  const [user] = useAuthState(auth);
  const [loading, setLoading] = useState(true);
  const [orders, setOrders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  // --- Data Fetching Function ---
  const fetchOrders = async () => {
    if (user?.email) {
      try {
        const response = await fetch(
          `https://imagetohtmlaiproject25-d0525ebf3976.herokuapp.com/orders?userEmail=${user.email}`
        );
        const info = await response.json();
        // Sort by createdAt descending (latest first)
        const sortedInfo = info.sort((a, b) => {
          const dateA = new Date(a.createdAt || 0);
          const dateB = new Date(b.createdAt || 0);
          return dateB - dateA; // Descending order
        });
        setOrders(sortedInfo);
      } catch (error) {
        console.error("Error fetching orders:", error);
        toast.error("Could not load orders. Please try again.");
      }
    }
  };

  // --- Initial Data Fetch on Component Mount/User Change ---
  useEffect(() => {
    const fetchData = async () => {
      if (user?.email) {
        setLoading(true);
        await fetchOrders();
        setLoading(false);
      } else {
        setLoading(false);
      }
    };
    fetchData();
  }, [user]);

  // --- Filtering Pending Orders ---
  const pendingOrders = orders.filter(
    (order) =>
      order.paymentStatus && order.paymentStatus.toLowerCase() === "pending"
  );

  // --- Pagination Logic ---
  const getPaginatedOrders = (data, currentPage) => {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return data.slice(indexOfFirstItem, indexOfLastItem);
  };

  const paginatedOrders = getPaginatedOrders(pendingOrders, currentPage);
  const totalPages = Math.ceil(pendingOrders.length / itemsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // --- Utility Functions for UI ---
  const getStatusBadgeClass = (status) => {
    if (!status) return "bg-info text-white";
    status = status.toLowerCase();
    if (status === "pending") return "bg-warning text-dark";
    if (status === "completed") return "bg-success text-white";
    return "bg-info text-white";
  };

  const getPayNowLink = (order) => {
    return `/pay-now/${order._id}`;
  };

  // --- Loading State ---
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <div
          className="spinner-border text-primary"
          role="status"
          style={{ width: "3rem", height: "3rem" }}
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Pending Orders | Your Website</title>
        <meta
          name="description"
          content="View and manage your pending orders. Complete payments to finalize your purchases."
        />
      </Helmet>
      <main className="container py-5">
        {/* Page Header */}
        <div className="row mb-4">
          <div className="col-12">
            <div className="card shadow-sm border-0">
              <div className="card-body p-4">
                <h2 className="card-title fs-3 fw-bold mb-1">
                  My Pending Orders
                </h2>
                <p className="text-muted mb-0">
                  Manage all your pending payments for your purchases.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Orders Section */}
        <div className="card border-0 shadow-sm">
          <div className="card-header bg-white py-3 border-0">
            <div className="d-flex justify-content-between align-items-center">
              <h3 className="fs-4 fw-bold mb-0">Pending Orders</h3>
            </div>
          </div>
          <div className="card-body p-0">
            {/* Desktop Table View */}
            <div className="table-responsive d-none d-md-block">
              <table className="table table-hover align-middle mb-0">
                <thead className="bg-light">
                  <tr>
                    <th className="py-3 ps-4">Order Info</th>
                    <th className="py-3">Amount</th>
                    <th className="py-3">Status</th>
                    <th className="py-3 text-end pe-4">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedOrders.length > 0 ? (
                    paginatedOrders.map((order) => (
                      <tr key={order._id}>
                        <td className="py-3 ps-4">
                          <div className="d-flex align-items-center">
                            <div
                              className="rounded-3 bg-light d-flex align-items-center justify-content-center me-3"
                              style={{
                                width: "48px",
                                height: "48px",
                                overflow: "hidden",
                              }}
                            >
                              <img
                                src={
                                  order.featuredImage ||
                                  "/assets/img/dashboard/orders/o-1.png"
                                }
                                alt={order.packageName || "Order"}
                                className="img-fluid"
                                style={{
                                  objectFit: "cover",
                                  width: "100%",
                                  height: "100%",
                                }}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src =
                                    "https://placehold.co/48x48/e9ecef/6c757d?text=FB";
                                }}
                              />
                            </div>
                            <div>
                              <h6 className="fw-bold mb-1">
                                {order.packageName || "Unnamed Package"}
                              </h6>
                              <div className="d-flex flex-column flex-md-row align-md-items-center">
                                <small className="text-secondary me-md-3">
                                  ID: {order.orderId || "N/A"}
                                </small>
                                <small className="text-secondary d-none d-md-block">
                                  <i className="bi bi-calendar-date me-1"></i>
                                  {order.orderDate || "N/A"}
                                </small>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="py-3">
                          <span className="fw-bold">
                            ${order.packagePrice || "0.00"} USD
                          </span>
                        </td>
                        <td className="py-3">
                          <span
                            className={`badge rounded-pill ${getStatusBadgeClass(
                              order.paymentStatus
                            )} px-3 py-2`}
                            style={{ fontSize: "0.85rem" }}
                          >
                            {order.paymentStatus
                              ? order.paymentStatus[0].toUpperCase() +
                                order.paymentStatus.slice(1)
                              : "Pending"}
                          </span>
                        </td>
                        <td className="py-3 text-end pe-4 d-none d-md-table-cell">
                          <Link
                            to={getPayNowLink(order)}
                            className="btn btn-primary btn-sm rounded-pill px-3 fw-medium"
                          >
                            <i className="bi bi-credit-card me-1"></i> Pay Now
                          </Link>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center py-5">
                        <div className="d-flex flex-column align-items-center">
                          <div className="mb-3">
                            <i className="bi bi-inbox fs-1 text-secondary opacity-50"></i>
                          </div>
                          <h5 className="fw-semibold mb-2">
                            No Pending Orders
                          </h5>
                          <p className="text-muted">
                            You're all caught up with payments.
                          </p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {/* Mobile Card View */}
            <div className="d-block d-md-none">
              {paginatedOrders.length > 0 ? (
                paginatedOrders.map((order) => (
                  <div
                    key={order._id}
                    className="card mb-3 shadow-sm border-0"
                  >
                    <div className="card-body">
                      <div className="d-flex align-items-center mb-3">
                        <div
                          className="rounded-3 bg-light d-flex align-items-center justify-content-center me-3"
                          style={{
                            width: "48px",
                            height: "48px",
                            overflow: "hidden",
                          }}
                        >
                          <img
                            src={
                              order.featuredImage ||
                              "/assets/img/dashboard/orders/o-1.png"
                            }
                            alt={order.packageName || "Order"}
                            className="img-fluid"
                            style={{
                              objectFit: "cover",
                              width: "100%",
                              height: "100%",
                            }}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src =
                                "https://placehold.co/48x48/e9ecef/6c757d?text=FB";
                            }}
                          />
                        </div>
                        <div>
                          <h6 className="fw-bold mb-1">
                            {order.packageName || "Unnamed Package"}
                          </h6>
                          <small className="text-secondary">
                            ID: {order.orderId}
                          </small>
                          <br />
                          <small className="text-secondary">
                            <i className="bi bi-calendar-date me-1"></i>{" "}
                            {order.orderDate || "N/A"}
                          </small>
                        </div>
                      </div>
                      <div className="mb-2">
                        <strong>Amount:</strong>{" "}
                        <span className="fw-bold">
                          ${order.packagePrice || "0.00"} USD
                        </span>
                      </div>
                      <div className="mb-2">
                        <strong>Status:</strong>{" "}
                        <span
                          className={`badge rounded-pill ${getStatusBadgeClass(
                            order.paymentStatus
                          )} px-3 py-2`}
                          style={{ fontSize: "0.85rem" }}
                        >
                          {order.paymentStatus
                            ? order.paymentStatus[0].toUpperCase() +
                              order.paymentStatus.slice(1)
                            : "Pending"}
                        </span>
                      </div>
                      <div className="text-center">
                        <Link
                          to={getPayNowLink(order)}
                          className="btn btn-primary rounded-pill px-4 py-2 fw-medium mt-2"
                        >
                          <i className="bi bi-credit-card me-1"></i> Pay Now
                        </Link>
                      </div>
                    </div>
                    <hr></hr>
                  </div>
                ))
              ) : (
                <div className="text-center py-5">
                  <i className="bi bi-inbox fs-1 text-secondary opacity-50 mb-3"></i>
                  <h5 className="fw-semibold">No Pending Orders</h5>
                  <p className="text-muted">
                    You're all caught up with payments.
                  </p>
                </div>
              )}
            </div>
            {/* Pagination */}
            {pendingOrders.length > itemsPerPage && (
              <div className="d-flex justify-content-center py-3 border-top">
                <nav aria-label="Page navigation">
                  <ul className="pagination">
                    <li
                      className={`page-item ${
                        currentPage === 1 ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                        aria-label="Previous"
                      >
                        <span aria-hidden="true">&laquo;</span>
                      </button>
                    </li>
                    {[...Array(totalPages)].map((_, i) => (
                      <li
                        key={`page-${i + 1}`}
                        className={`page-item ${
                          currentPage === i + 1 ? "active" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(i + 1)}
                        >
                          {i + 1}
                        </button>
                      </li>
                    ))}
                    <li
                      className={`page-item ${
                        currentPage === totalPages ? "disabled" : ""
                      }`}
                    >
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        aria-label="Next"
                      >
                        <span aria-hidden="true">&raquo;</span>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
          </div>
        </div>

        {/* Additional Info Card */}
        <div className="card border-0 shadow-sm mt-4">
          <div className="card-body p-4">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h4 className="fs-5 fw-bold mb-2">Complete Your Purchase</h4>
                <p className="mb-0 text-secondary">
                  Your orders are pending payment. Complete the payment process
                  to gain immediate access to your purchased items.
                </p>
              </div>
              <div className="col-md-4 text-md-end mt-3 mt-md-0">
                {pendingOrders.length > 0 ? (
                  <Link
                    to={getPayNowLink(pendingOrders[0])}
                    className="btn btn-primary rounded-pill px-4 py-2 fw-medium"
                  >
                    <i className="bi bi-credit-card me-2"></i> Pay First Order
                  </Link>
                ) : (
                  <p className="text-muted mb-0 d-md-inline-block">
                    No payments due.
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
      {/* Add Bootstrap Icons CSS */}
      <Helmet>
        <link
          rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.5/font/bootstrap-icons.css"
        />
      </Helmet>
    </>
  );
};

export default PendingOrders;